import { Component, computed, effect, inject, Signal } from '@angular/core';
import { CompanyCooperationsListComponent } from '@app/shared/components/cooperations/company-cooperations-list/company-cooperations-list.component';
import { ActiveCompanyService } from '@app/shared/services/active-company.service';
import { CooperationsDataService } from '@app/shared/services/cooperations-data.service';
import { Company } from '@app/shared/types/models/company/company.model';
import { UiPageWrapperComponent } from '@app/shared/ui/page-wrapper/ui-page-wrapper.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-company-cooperations',
  standalone: true,
  templateUrl: './company-cooperations-view.component.html',
  imports: [UiPageWrapperComponent, TranslatePipe, CompanyCooperationsListComponent]
})
export class CompanyCooperationsViewComponent {
  private readonly activeCompanyService = inject(ActiveCompanyService);
  private readonly cooperationsService = inject(CooperationsDataService);

  protected activeCompany: Signal<Company | undefined> = this.activeCompanyService.activeCompany;

  protected incoming = computed(() => {
    const company = this.activeCompany();
    if (!company?.id) return undefined;
    return this.cooperationsService.getIncoming(company.id)();
  });

  protected outgoing = computed(() => {
    const company = this.activeCompany();
    if (!company?.id) return undefined;
    return this.cooperationsService.getOutgoing(company.id)();
  });

  public constructor() {
    effect(() => {
      const company = this.activeCompany();
      if (company?.id) {
        this.cooperationsService.loadIncoming(company.id);
        this.cooperationsService.loadOutgoing(company.id);
      }
    });
  }
}
